<template>
  <div class="position">
    <!--<router-link to="/home">
        <img class="icon" src="../../assets/shouye.png" alt="">
    </router-link>-->
    <!--todo new 20260305 新加返回搜索页方法 start-->
    <img
            class="icon"
            src="../../assets/shouye.png"
            alt="返回/首页"
            @click="goBack"
            style="cursor: pointer;"
    >
    <!--todo new 20260305 新加返回搜索页方法 end-->

    <img @touchstart.stop.prevent="back()" @click="back()" class="icon margingLeft" src="../../assets/mulu.png" alt="">
  </div>
</template>

<script>
export default {
  props:["category_id"],
  data () {
    return {
      home: '',
      // id:"111"
    }
  },
  created(){
  },
  methods:{
    back(){
         var type=this.$route.query.type;//type类型，1是文档(pdf)要返回两次才回上一页
          var hToL=sessionStorage.getItem("hToL");
         var lToD=sessionStorage.getItem("lToD");    //第二级页面加载时存储的lToD
         var pdf=sessionStorage.getItem("pdf");
          if(lToD==null && hToL==null){  //第一次打开的是三级页面，返回要跳转到二级页面
              this.$router.push(`list?id=${this.category_id}`)
          }else if(type==1 && pdf==1 && hToL==null){         //加条件，为了预防首页banner跳转的pdf页面，首页直接跳转pdf是没有lToD
              this.$router.go(-1);
          }else if(type==1){         //加条件，为了预防首页banner跳转的pdf页面，首页直接跳转pdf是没有lToD
              this.$router.go(-2);
          }else{
              this.$router.go(-1);
          }
    },
      //todo new 20260305 新加返回搜索页方法 start
    goBack(){
        //todo new 20260305 添加搜索关键字参数
        var keyWord=this.$route.query.keyWord;//keyWord搜索关键字
        //console.log(keyWord);
        if(keyWord){
            console.log(keyWord);
            //this.$router.back();
            //this.$router.go(-1);
            this.$router.push(`search?keyWord=${keyWord}`);
        }else{
            //this.$router.push({ name: 'home' });
            this.$router.push('/');
        }
    },
      //todo new 20260305 新加返回搜索页方法 end
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .position{
      cursor: pointer;
        position: absolute;;
        color:#ccc;
        top:35px;
        left:22px;
        z-index:1;
    }
    .position .icon{
        width:44px;
    }
    .margingLeft{
      margin-left:6px;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/back.vue